import Vue from 'vue';
import NProgress from 'vue-nprogress';
import axios from 'axios';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import VueTextareaAutosize from 'vue-textarea-autosize';
import moment from 'moment';
import queryString from 'query-string';
import { AppModel } from './models';
import App from './App.vue';
import router from './router';
import {Api} from './api';
import {BVCDLogin, EventBus, Browser} from './utils';
import PercentageBackgroundColorPlugin from './plugins/PercentageBackgroundColorPlugin';
import GetCurrencyPlugin from './plugins/GetCurrencyPlugin';
import './vee-validate/vee-validate.js';
import { i18nValidation as i18n, lang } from './localize.js';
Vue.use(NProgress);
Vue.use(PercentageBackgroundColorPlugin);
Vue.use(GetCurrencyPlugin);
Vue.use(VueTextareaAutosize);
const $http = axios.create();

AppModel.setLang(lang);

Vue.config.lang = lang;
Vue.config.fallbackLang = lang;
Vue.config.devtools = process.env.NODE_ENV !== 'production';
const HAS_BVCD = !!process.env.HAS_BVCD;
moment.locale(Vue.config.lang);

const parsedQs = queryString.parse(location.search);
if(parsedQs['token']) {
    Api.user.setToken(parsedQs['token']);
    if(parsedQs['slug']) {
        router.push({name: 'change-campground', params: {campground: parsedQs['slug']}});
    }
    window.location = window.location.href.split('?')[0];
}

Browser.init();
// Tracking.init(); // This disabled Google Analytics
if(HAS_BVCD) {
    BVCDLogin.setup();
}

const nprogress = new NProgress({parent: '.nprogress-container'});

function serverOffline() {
    console.warn('Backend seems to be offline');
    EventBus.$emit(EventBus.ERROR, {code: 503});
}

function unauthorized() {
    console.warn('User is not authorized. Logging out...');
    router.replace({name: 'logout'});
}

axios.interceptors.request.use((config) => {
    const token = Api.user.getToken();

    if(token) {
        axios.defaults.headers.common['Authorization'] = `Token ${token}`;
        axios.defaults.headers['Content-Type'] = 'application/json';
    }
});

/**
 * HTTP Interceptors for requests
 */
$http.interceptors.request.use((config) => {
    const token = Api.user.getToken();

    if(token) {
        config.headers.common['Authorization'] = `Token ${token}`;
    }
    return config;
}, (error) => {
    // Do something with request error
    return Promise.reject(error);
});

/**
 * HTTP Interceptors for response
 */
$http.interceptors.response.use((response) => {
    if(response.status === 401) {
        unauthorized();
    } else if(response.status === 0) {
        serverOffline();
    }
    response['ok'] = Math.floor(response.status / 100) === 2;
    response['body'] = response.data;
    return response;
}, (error) => {
    console.log('error', error.response);
    if(!error.response) {
        serverOffline();
        return error;
    }

    if(error.response.status === 401) {
        unauthorized();
    } else if(error.response.status === 0) {
        serverOffline();
    }

    error['ok'] = false;
    error['body'] = error.response.data;
    error['status'] = error.response.status;
    return error;
});

const SENTRY_DSN = process.env.SENTRY_DSN || '';
if(SENTRY_DSN) {
    console.debug('activating sentry');
    Raven.config(SENTRY_DSN).addPlugin(RavenVue, Vue).install();
}
Vue.prototype.$http = $http;
new Vue({ // eslint-disable-line no-new
    el: '#app',
    router,
    nprogress,
    i18n,
    render: (h) => h(App),
});

console.debug(`CampNerd CHANGER Admin Version ${process.env.COMMITHASH || 'unknown'}`);



// WEBPACK FOOTER //
// ./src/main.js